import { GitPullRequest } from 'lucide-react'
import type { Bug } from '../../data/projectTypes'
import { githubTestRunPath } from '../../lib/githubTestRun'
import { Link } from '../nav'
import PullRequestCheckStatus from '../PullRequestCheckStatus'
import './BugPullRequests.css'

export default function BugPullRequests({ bug }: { bug: Bug }) {
  if (!bug.fix_prs?.length) return null

  return (
    <ul className="bug-pull-requests" aria-label="Fix pull requests">
      {bug.fix_prs.map(pr => {
        const status = pr.merged_at || pr.pr_state === 'merged'
          ? 'Merged'
          : pr.pr_state === 'closed' ? 'Closed'
          : pr.pr_state === 'open' ? 'Open' : 'Status unavailable'
        return (
          <li className="bug-pull-requests__item" key={`${pr.repo_full_name}#${pr.pr_number}`}>
            <GitPullRequest size={14} aria-hidden="true" />
            <a
              href={`https://github.com/${pr.repo_full_name}/pull/${pr.pr_number}`}
              target="_blank"
              rel="noopener noreferrer"
              data-analytics-event="bug-fix-pr-link"
            >
              Fix PR # {pr.pr_number}
              <PullRequestCheckStatus projectId={bug.project_id} repo={pr.repo_full_name} pr={pr.pr_number} />
            </a>
            <span className="bug-pull-requests__status">{status}</span>
            {!pr.active && <span>Unlinked</span>}
            {pr.version_id && (
              <Link
                to={githubTestRunPath(bug.project_id, pr.version_id)}
                aria-label={`View test run for ${pr.repo_full_name}#${pr.pr_number}`}
                data-analytics-event="bug-fix-pr-test-run-link"
              >
                View test run
              </Link>
            )}
          </li>
        )
      })}
    </ul>
  )
}
